import { InlandCategory } from '@pelicargo/types';
import { CostUnitType, LineItemType, MarkupCategory, RateCategory, SurchargeCategory } from '@prisma/client';

export const isRateCategory = (type?: LineItemType | null): type is RateCategory => {
  if (!type) return false;
  return Object.values(RateCategory).includes(type as RateCategory);
};

export const isSurchargeCategory = (type?: LineItemType): type is SurchargeCategory => {
  if (!type) return false;
  return Object.values(SurchargeCategory).includes(type as SurchargeCategory);
};

export const isMarkupCategory = (type?: LineItemType): type is MarkupCategory => {
  if (!type) return false;
  return Object.values(MarkupCategory).includes(type as MarkupCategory);
};

export const isInlandCategory = (type?: LineItemType): type is InlandCategory => {
  if (!type) return false;
  return Object.values(InlandCategory).includes(type as InlandCategory);
};

export const isPercentage = (costUnitType: CostUnitType) => {
  return costUnitType === CostUnitType.PERCENTAGE;
};
